module.exports = __webpack_public_path__ + "img/2010.b30f6add.jpg";